import { render } from "./MoveContract.vue?vue&type=template&id=47d502d8&scoped=true"
import script from "./MoveContract.vue?vue&type=script&lang=js"
export * from "./MoveContract.vue?vue&type=script&lang=js"

import "./MoveContract.vue?vue&type=style&index=0&id=47d502d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d502d8"]])

export default __exports__